const BaseView = require('../components/common/common-component');
const AnalyticsDecorate = require('../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('./analytics/view'), BaseView.extend({
  type: 'video',
  updateSearchContainer: $.noop,

  isAlreadyThere: function () {
    return !!this.$el.find('.tab-content.video').length;
  },

  render: async function () {
    await BaseView.prototype.render.call(this);
    const $libraryTab = this.$headerLinks.filter('[data-key=library], [data-key=user_library]');

    $libraryTab.length && !this.isEnterprise
      ? $libraryTab.trigger('click')
      : BaseView.prototype.checkEmptyLibrary.call(this, $libraryTab);
  }
}));
